var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 9.66663V4.33329C3.66699 2.86063 4.86099 1.66663 6.33366 1.66663C7.80633 1.66663 9.00033 2.86063 9.00033 4.33329V13.6666C9.00033 15.1393 10.1943 16.3333 11.667 16.3333C13.1397 16.3333 14.3337 15.1393 14.3337 13.6666V8.33329",
    stroke: "#9747FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.334 5.66663C15.4386 5.66663 16.334 4.7712 16.334 3.66663C16.334 2.56206 15.4386 1.66663 14.334 1.66663C13.2294 1.66663 12.334 2.56206 12.334 3.66663C12.334 4.7712 13.2294 5.66663 14.334 5.66663Z",
    stroke: "#9747FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 16.3333C4.77156 16.3333 5.66699 15.4378 5.66699 14.3333C5.66699 13.2287 4.77156 12.3333 3.66699 12.3333C2.56242 12.3333 1.66699 13.2287 1.66699 14.3333C1.66699 15.4378 2.56242 16.3333 3.66699 16.3333Z",
    stroke: "#9747FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.14610e1f5677b14d97a76a1e116f22a5.svg";
export { ForwardRef as ReactComponent };